import { IResultRow } from '@/services/api/nswag/stapiclient_generated';

export class PagerRow {
  totalItems?: number;
  page?: number;
  remainingItems?: number;
  visibleItems?: number;
  totalPages?: number;
}
